import { LitElement, html, css } from 'lit'
import {customElement, property, query, state} from 'lit/decorators.js'
import { TConversation } from "./vxc_conversation"
import { TDialog } from './vxc_dialog'

@customElement('vxc-session-dialog-view')
export class TSessionDialogView extends LitElement {

    /** properties */
    @property({ type: Boolean }) visible: boolean = false   
    @property({ type: String })  host: string = ''   
    @property({ type: String })  app : string = ''
    @property({ type: String })  uid : string = ''
    @query('vxc-dialog') private dialog!: TDialog
    @state() private data: any = {}
    @state() private error: string | null = null


    updated(changedProperties: Map<string | number | symbol, unknown>) {
        console.log('session view :')
        console.dir(changedProperties)
        console.log('uid ?', changedProperties.has('uid'))
        console.log('app ?', changedProperties.has('uid'))
        if (changedProperties.has('uid') || changedProperties.has('app')) {
            console.log('uid :', this.uid, 'app :', this.app)
            this.fetchData();
        }
        else console.log('ignoring...')
        super.update(changedProperties)
    }    

    async fetchData() {
        console.log('fetching', this.app, this.uid)
        
        if (!this.uid || !this.app) {
            this.data = {};
            this.error = null;
            return;
        }

        try {
            const response = await fetch(`${this.host}/apps/${this.app}/chat/${this.uid}`)
            if (!response.ok) throw new Error(`Error: ${response.statusText}`);
            const session = await response.json()
            if(!session?.dialog)    throw new Error('Session not found..')
            this.data = session
            this.error = null
        } 
        catch (err: any) {
            this.error = err.message;
            this.data = {};
        }
    }

    public show() {
        this.visible = true
        this.dialog.open()
    } 

    render() {
        console.log('this.visible', this.visible)
        if(this.data?.uid && this.data?.dialog) {
            const ts = new Date(this.data.begin)
            return html`
            <vxc-dialog 
                title="${this.data.topic||''} (session du ${ts.toLocaleString('fr-FR')})" 
                ?show=${this.visible}>
                <vxc-conversation 
                    dialog=${JSON.stringify(this.data.dialog||[])}
                    enable-attachments
                    disable-review>
                </vxc-conversation>
            </vxc-dialog>
            `
        }
        return html``
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-session-dialog-view': TSessionDialogView
  }
}


